import React, { useEffect, useState } from "react";
import "./AutomobileInsurance.css";
import insuranceImg from "../../assets/img/insurance/automobile.svg";
import check_circle from "../../assets/img/insurance/check_circle.svg";
import right_layout_image_Car from "../../assets/img/insurance/right_layout_image_Car.svg";
import right_layout_image_Car_M from "../../assets/img/insurance/right_layout_image_Car_M.svg";
import { Container, Row, Col } from "react-bootstrap";

const AutomobileInsurances = ({ responsiveStatus }) => (
  <div className={`flex-1 text-left `} style={{ padding: "20px" }}>
    <p
      className={`${
        responsiveStatus === "isDesktop"
          ? "p-class"
          : responsiveStatus === "isTablet" ||
            responsiveStatus === "isTabletLandscape"
          ? "p-class"
          : "p-class"
      }`}
    >
      <span
        style={{
          position: "relative",
          paddingBottom: ".5em",
        }}
      >
        <span className="blue-underline" style={{ paddingBottom: "5px" }}>
          Automobile{" "}
        </span>
        Insurance
      </span>
    </p>

    <p
      className="text-gray-700 mb-6 max-w-md mx-auto"
      style={{ marginTop: "0.5em" }}
    >
      Whether it's for your car, truck, or SUV, your independent insurance agent
      is ready to talk about your coverage needs and explain everything you need
      to know.
    </p>
    <ul style={{ listStyle: "none", padding: 0, margin: 0, marginTop: "20px" }}>
      {[
        "Low rates & money-saving discounts.",
        "Personalized coverage options.",
        "Expert advice from your local independent insurance agent.",
        "Superior claims service.",
      ].map((item, i) => (
        <li
          key={i}
          style={{
            marginBottom: "12px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={check_circle}
            alt="check"
            style={{ width: "20px", marginRight: "10px" }}
          />
          <span className="textStyle" style={{ fontSize: "16px" }}>
            {item}
          </span>
        </li>
      ))}
    </ul>

    {(responsiveStatus === "isMobile" ||
      responsiveStatus === "isSmallMobile") && (
      <img
        src={right_layout_image_Car_M}
        className={`img-fluid ${
          responsiveStatus === "isDesktop"
            ? "aboutRightImage3"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "aboutRightImage3"
            : "aboutRightImage4"
        }`}
        alt="Car"
        style={{ maxWidth: "100%", height: "auto", width: "100%" }}
      />
    )}
  </div>
);

const AutomobileInsurance = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  // const ITEMS_PER_PAGE = 4;

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  return (
    <>
      <div
        className=""
        style={{
          marginLeft: "0px",
          padding: "0px",
          display: "flex",
          flexWrap: "wrap",
          maxWidth: "1350px",
          margin: "0 auto",
        }}
      >
        <div
          className="d-flex flex-column justify-content-center"
          style={{
            backgroundColor: "#D8f4FF",
            width:
              responsiveStatus === "isDesktop"
                ? "48.5%"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "48.5%"
                : "100%",
          }}
        >
          <AutomobileInsurances responsiveStatus={responsiveStatus} />
        </div>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            backgroundColor:
              responsiveStatus === "isDesktop"
                ? "#D8f4FF"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "#D8f4FF"
                : "",

            padding: "0px",
            width:
              responsiveStatus === "isDesktop"
                ? "51.5%"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "51.5%"
                : "100%",
          }}
        >
          {responsiveStatus !== "isMobile" &&
            responsiveStatus !== "isSmallMobile" && (
              <img
                src={right_layout_image_Car}
                className={`img-fluid ${
                  responsiveStatus === "isDesktop"
                    ? "aboutRightImage3"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "aboutRightImage3"
                    : "aboutRightImage4"
                }`}
                alt="Car"
                style={{ maxWidth: "100%", height: "auto", width: "100%" }}
              />
            )}
        </div>
      </div>
    </>
  );
};

const styles = {
  rightImage: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "auto",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${right_layout_image_Car})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

export default AutomobileInsurance;
